import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import Logo from './Logo';

interface MobileTopBarProps {
    onOpenSidebar: () => void;
    /** Right side of the bar, before the theme button: the sync indicator on phones. */
    trailing?: React.ReactNode;
    /** Far right: the account chip on phones. */
    account?: React.ReactNode;
    /** Below 1024 px the theme button sits here instead of in the menu (phone-top-bar). */
    theme?: { isDarkMode: boolean; onToggle: () => void };
}

const MobileTopBar: React.FC<MobileTopBarProps> = ({ onOpenSidebar, trailing, account, theme }) => {
    return (
        <div className="lg:hidden sticky top-0 z-40 flex items-center justify-between gap-2 px-4 py-2.5">
            {/* Glass on its own layer: a backdrop-filter on the bar would stop the account
                menu inside it from blurring the page behind. */}
            <div aria-hidden="true" className="absolute inset-0 -z-10 bg-theme border-b border-theme glass" />
            <div className="flex shrink-0 items-center gap-3">
                <button
                    onClick={onOpenSidebar}
                    data-testid="NAV_MOBILE_OPEN"
                    className="p-2 -ml-2 text-theme-secondary hover:text-theme transition-colors rounded-lg hover:bg-theme-card-hover"
                    aria-label="Open sidebar"
                >
                    <FontAwesomeIcon icon={faBars} className="text-xl" />
                </button>
                <Logo variant="wordmark" size={24} />
            </div>
            {(trailing || theme || account) && (
                <div className="flex min-w-0 items-center justify-end gap-2">
                    {trailing}
                    {theme && (
                        <button
                            type="button"
                            data-testid="NAV_MOBILE_THEME_TOGGLE"
                            onClick={theme.onToggle}
                            aria-label={theme.isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                            className="shrink-0 h-11 w-11 flex items-center justify-center text-theme-secondary hover:text-theme transition-colors rounded-lg hover:bg-theme-card-hover"
                        >
                            <FontAwesomeIcon icon={theme.isDarkMode ? faSun : faMoon} className="text-lg" aria-hidden />
                        </button>
                    )}
                    {account}
                </div>
            )}
        </div>
    );
};

export default MobileTopBar;
